import classNames from "classnames";
import type { HTMLAttributes } from "react";

export default function RutubeIcon({
  className,
  ...rest
}: HTMLAttributes<HTMLSpanElement>) {
  return (
    <span className={classNames("anticon", className)} {...rest}>
      <svg width="1em" height="1em" viewBox="0 0 112 98" fill="currentColor">
        <path d="M59.0071 59.2582H17.5723V42.6574H59.0071C61.4274 42.6574 63.1103 43.0845 63.9548 43.8304C64.7994 44.5763 65.3226 45.9597 65.3226 47.9806V53.9414C65.3226 56.0707 64.7994 57.4541 63.9548 58.2C63.1103 58.9459 61.4274 59.2646 59.0071 59.2646V59.2582ZM61.8497 27.0064H0V98H17.5723V74.9028H49.9562L65.3226 98H85L68.058 74.7945C74.3041 73.8573 77.1089 71.9193 79.422 68.7253C81.7351 65.5314 82.8949 60.4249 82.8949 53.6099V48.2866C82.8949 44.2448 82.4726 41.0508 81.7351 38.6028C80.9977 36.1547 79.7371 34.0254 77.9471 32.1129C76.0563 30.3023 73.9511 29.0273 71.4237 28.173C68.8963 27.4271 65.7385 27 61.8497 27V27.0064Z" />
        <path d="M98.5 27C105.956 27 112 20.9558 112 13.5C112 6.04416 105.956 0 98.5 0C91.0442 0 85 6.04416 85 13.5C85 20.9558 91.0442 27 98.5 27Z" />
      </svg>
    </span>
  );
}
